/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EarlyPaymentsApproveRouteImport } from './routes/early-payments/approve'
import { Route as EmployeesIndexRouteImport } from './routes/employees/index'
import { Route as ErpIndexRouteImport } from './routes/erp/index'
import { Route as ReimbursementsListRouteImport } from './routes/reimbursements/list'

const AccountIndexLazyRouteImport = createFileRoute('/account/')()
const AccountNewTestUserLazyRouteImport = createFileRoute(
  '/account/new-test-user',
)()
const AuthForgotPasswordLazyRouteImport = createFileRoute(
  '/auth/forgot-password',
)()
const AuthLoginLazyRouteImport = createFileRoute('/auth/login')()
const AuthResetPasswordLazyRouteImport = createFileRoute(
  '/auth/reset-password',
)()
const EarlyPaymentsNewRequestLazyRouteImport = createFileRoute(
  '/early-payments/new-request',
)()
const EarlyPaymentsRequestsLazyRouteImport = createFileRoute(
  '/early-payments/requests',
)()
const EarlyPaymentsSettingsLazyRouteImport = createFileRoute(
  '/early-payments/settings',
)()
const EmployeesAddLazyRouteImport = createFileRoute('/employees/add')()
const EmployeesEditSalaryLazyRouteImport = createFileRoute(
  '/employees/edit-salary',
)()
const EmployeesExportsLazyRouteImport = createFileRoute('/employees/exports')()
const EnterprisesOverviewLazyRouteImport = createFileRoute(
  '/enterprises/overview',
)()
const EnterprisesUsersLazyRouteImport = createFileRoute('/enterprises/users')()
const ErpMovementsLazyRouteImport = createFileRoute('/erp/movements')()
const ErpProductsLazyRouteImport = createFileRoute('/erp/products')()
const FormsIndexLazyRouteImport = createFileRoute('/forms/')()
const ReimbursementsCreateLazyRouteImport = createFileRoute(
  '/reimbursements/create',
)()
const StoresIndexLazyRouteImport = createFileRoute('/stores/')()
const EmployeesEmployeeIdEditLazyRouteImport = createFileRoute(
  '/employees/$employeeId/edit',
)()
const EmployeesEmployeeIdRecordsLazyRouteImport = createFileRoute(
  '/employees/$employeeId/records',
)()
const FormsIdFormIdLazyRouteImport = createFileRoute('/forms/id/$formId')()

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountIndexLazyRoute = AccountIndexLazyRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/account/index.lazy').then((d) => d.Route))
const AccountNewTestUserLazyRoute = AccountNewTestUserLazyRouteImport.update({
  id: '/account/new-test-user',
  path: '/account/new-test-user',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/account/new-test-user.lazy').then((d) => d.Route),
)
const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/auth/forgot-password.lazy').then((d) => d.Route),
)
const AuthLoginLazyRoute = AuthLoginLazyRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/auth/login.lazy').then((d) => d.Route))
const AuthResetPasswordLazyRoute = AuthResetPasswordLazyRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/auth/reset-password.lazy').then((d) => d.Route),
)
const EarlyPaymentsApproveRoute = EarlyPaymentsApproveRouteImport.update({
  id: '/early-payments/approve',
  path: '/early-payments/approve',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/early-payments/approve.lazy').then((d) => d.Route),
)
const EarlyPaymentsNewRequestLazyRoute =
  EarlyPaymentsNewRequestLazyRouteImport.update({
    id: '/early-payments/new-request',
    path: '/early-payments/new-request',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/early-payments/new-request.lazy').then((d) => d.Route),
  )
const EarlyPaymentsRequestsLazyRoute =
  EarlyPaymentsRequestsLazyRouteImport.update({
    id: '/early-payments/requests',
    path: '/early-payments/requests',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/early-payments/requests.lazy').then((d) => d.Route),
  )
const EarlyPaymentsSettingsLazyRoute =
  EarlyPaymentsSettingsLazyRouteImport.update({
    id: '/early-payments/settings',
    path: '/early-payments/settings',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/early-payments/settings.lazy').then((d) => d.Route),
  )
const EmployeesIndexRoute = EmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/employees/index.lazy').then((d) => d.Route),
)
const EmployeesAddLazyRoute = EmployeesAddLazyRouteImport.update({
  id: '/employees/add',
  path: '/employees/add',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/employees/add.lazy').then((d) => d.Route))
const EmployeesEditSalaryLazyRoute = EmployeesEditSalaryLazyRouteImport.update({
  id: '/employees/edit-salary',
  path: '/employees/edit-salary',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/employees/edit-salary.lazy').then((d) => d.Route),
)
const EmployeesExportsLazyRoute = EmployeesExportsLazyRouteImport.update({
  id: '/employees/exports',
  path: '/employees/exports',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/employees/exports.lazy').then((d) => d.Route),
)
const EnterprisesOverviewLazyRoute = EnterprisesOverviewLazyRouteImport.update({
  id: '/enterprises/overview',
  path: '/enterprises/overview',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/enterprises/overview.lazy').then((d) => d.Route),
)
const EnterprisesUsersLazyRoute = EnterprisesUsersLazyRouteImport.update({
  id: '/enterprises/users',
  path: '/enterprises/users',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/enterprises/users.lazy').then((d) => d.Route),
)
const ErpIndexRoute = ErpIndexRouteImport.update({
  id: '/erp/',
  path: '/erp/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/erp/index.lazy').then((d) => d.Route))
const ErpMovementsLazyRoute = ErpMovementsLazyRouteImport.update({
  id: '/erp/movements',
  path: '/erp/movements',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/erp/movements.lazy').then((d) => d.Route))
const ErpProductsLazyRoute = ErpProductsLazyRouteImport.update({
  id: '/erp/products',
  path: '/erp/products',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/erp/products.lazy').then((d) => d.Route))
const FormsIndexLazyRoute = FormsIndexLazyRouteImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/forms/index.lazy').then((d) => d.Route))
const ReimbursementsCreateLazyRoute =
  ReimbursementsCreateLazyRouteImport.update({
    id: '/reimbursements/create',
    path: '/reimbursements/create',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/reimbursements/create.lazy').then((d) => d.Route),
  )
const ReimbursementsListRoute = ReimbursementsListRouteImport.update({
  id: '/reimbursements/list',
  path: '/reimbursements/list',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/reimbursements/list.lazy').then((d) => d.Route),
)
const StoresIndexLazyRoute = StoresIndexLazyRouteImport.update({
  id: '/stores/',
  path: '/stores/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/stores/index.lazy').then((d) => d.Route))
const EmployeesEmployeeIdEditLazyRoute =
  EmployeesEmployeeIdEditLazyRouteImport.update({
    id: '/employees/$employeeId/edit',
    path: '/employees/$employeeId/edit',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/employees/$employeeId/edit.lazy').then((d) => d.Route),
  )
const EmployeesEmployeeIdRecordsLazyRoute =
  EmployeesEmployeeIdRecordsLazyRouteImport.update({
    id: '/employees/$employeeId/records',
    path: '/employees/$employeeId/records',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/employees/$employeeId/records.lazy').then((d) => d.Route),
  )
const FormsIdFormIdLazyRoute = FormsIdFormIdLazyRouteImport.update({
  id: '/forms/id/$formId',
  path: '/forms/id/$formId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forms/id.$formId.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/early-payments/approve': typeof EarlyPaymentsApproveRoute
  '/reimbursements/list': typeof ReimbursementsListRoute
  '/account/new-test-user': typeof AccountNewTestUserLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/reset-password': typeof AuthResetPasswordLazyRoute
  '/early-payments/new-request': typeof EarlyPaymentsNewRequestLazyRoute
  '/early-payments/requests': typeof EarlyPaymentsRequestsLazyRoute
  '/early-payments/settings': typeof EarlyPaymentsSettingsLazyRoute
  '/employees/add': typeof EmployeesAddLazyRoute
  '/employees/edit-salary': typeof EmployeesEditSalaryLazyRoute
  '/employees/exports': typeof EmployeesExportsLazyRoute
  '/enterprises/overview': typeof EnterprisesOverviewLazyRoute
  '/enterprises/users': typeof EnterprisesUsersLazyRoute
  '/erp/movements': typeof ErpMovementsLazyRoute
  '/erp/products': typeof ErpProductsLazyRoute
  '/reimbursements/create': typeof ReimbursementsCreateLazyRoute
  '/employees/': typeof EmployeesIndexRoute
  '/erp/': typeof ErpIndexRoute
  '/account/': typeof AccountIndexLazyRoute
  '/forms/': typeof FormsIndexLazyRoute
  '/stores/': typeof StoresIndexLazyRoute
  '/employees/$employeeId/edit': typeof EmployeesEmployeeIdEditLazyRoute
  '/employees/$employeeId/records': typeof EmployeesEmployeeIdRecordsLazyRoute
  '/forms/id/$formId': typeof FormsIdFormIdLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/early-payments/approve': typeof EarlyPaymentsApproveRoute
  '/reimbursements/list': typeof ReimbursementsListRoute
  '/account/new-test-user': typeof AccountNewTestUserLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/reset-password': typeof AuthResetPasswordLazyRoute
  '/early-payments/new-request': typeof EarlyPaymentsNewRequestLazyRoute
  '/early-payments/requests': typeof EarlyPaymentsRequestsLazyRoute
  '/early-payments/settings': typeof EarlyPaymentsSettingsLazyRoute
  '/employees/add': typeof EmployeesAddLazyRoute
  '/employees/edit-salary': typeof EmployeesEditSalaryLazyRoute
  '/employees/exports': typeof EmployeesExportsLazyRoute
  '/enterprises/overview': typeof EnterprisesOverviewLazyRoute
  '/enterprises/users': typeof EnterprisesUsersLazyRoute
  '/erp/movements': typeof ErpMovementsLazyRoute
  '/erp/products': typeof ErpProductsLazyRoute
  '/reimbursements/create': typeof ReimbursementsCreateLazyRoute
  '/employees': typeof EmployeesIndexRoute
  '/erp': typeof ErpIndexRoute
  '/account': typeof AccountIndexLazyRoute
  '/forms': typeof FormsIndexLazyRoute
  '/stores': typeof StoresIndexLazyRoute
  '/employees/$employeeId/edit': typeof EmployeesEmployeeIdEditLazyRoute
  '/employees/$employeeId/records': typeof EmployeesEmployeeIdRecordsLazyRoute
  '/forms/id/$formId': typeof FormsIdFormIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/early-payments/approve': typeof EarlyPaymentsApproveRoute
  '/reimbursements/list': typeof ReimbursementsListRoute
  '/account/new-test-user': typeof AccountNewTestUserLazyRoute
  '/auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/reset-password': typeof AuthResetPasswordLazyRoute
  '/early-payments/new-request': typeof EarlyPaymentsNewRequestLazyRoute
  '/early-payments/requests': typeof EarlyPaymentsRequestsLazyRoute
  '/early-payments/settings': typeof EarlyPaymentsSettingsLazyRoute
  '/employees/add': typeof EmployeesAddLazyRoute
  '/employees/edit-salary': typeof EmployeesEditSalaryLazyRoute
  '/employees/exports': typeof EmployeesExportsLazyRoute
  '/enterprises/overview': typeof EnterprisesOverviewLazyRoute
  '/enterprises/users': typeof EnterprisesUsersLazyRoute
  '/erp/movements': typeof ErpMovementsLazyRoute
  '/erp/products': typeof ErpProductsLazyRoute
  '/reimbursements/create': typeof ReimbursementsCreateLazyRoute
  '/employees/': typeof EmployeesIndexRoute
  '/erp/': typeof ErpIndexRoute
  '/account/': typeof AccountIndexLazyRoute
  '/forms/': typeof FormsIndexLazyRoute
  '/stores/': typeof StoresIndexLazyRoute
  '/employees/$employeeId/edit': typeof EmployeesEmployeeIdEditLazyRoute
  '/employees/$employeeId/records': typeof EmployeesEmployeeIdRecordsLazyRoute
  '/forms/id/$formId': typeof FormsIdFormIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/early-payments/approve'
    | '/reimbursements/list'
    | '/account/new-test-user'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/early-payments/new-request'
    | '/early-payments/requests'
    | '/early-payments/settings'
    | '/employees/add'
    | '/employees/edit-salary'
    | '/employees/exports'
    | '/enterprises/overview'
    | '/enterprises/users'
    | '/erp/movements'
    | '/erp/products'
    | '/reimbursements/create'
    | '/employees/'
    | '/erp/'
    | '/account/'
    | '/forms/'
    | '/stores/'
    | '/employees/$employeeId/edit'
    | '/employees/$employeeId/records'
    | '/forms/id/$formId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/early-payments/approve'
    | '/reimbursements/list'
    | '/account/new-test-user'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/early-payments/new-request'
    | '/early-payments/requests'
    | '/early-payments/settings'
    | '/employees/add'
    | '/employees/edit-salary'
    | '/employees/exports'
    | '/enterprises/overview'
    | '/enterprises/users'
    | '/erp/movements'
    | '/erp/products'
    | '/reimbursements/create'
    | '/employees'
    | '/erp'
    | '/account'
    | '/forms'
    | '/stores'
    | '/employees/$employeeId/edit'
    | '/employees/$employeeId/records'
    | '/forms/id/$formId'
  id:
    | '__root__'
    | '/'
    | '/early-payments/approve'
    | '/reimbursements/list'
    | '/account/new-test-user'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/reset-password'
    | '/early-payments/new-request'
    | '/early-payments/requests'
    | '/early-payments/settings'
    | '/employees/add'
    | '/employees/edit-salary'
    | '/employees/exports'
    | '/enterprises/overview'
    | '/enterprises/users'
    | '/erp/movements'
    | '/erp/products'
    | '/reimbursements/create'
    | '/employees/'
    | '/erp/'
    | '/account/'
    | '/forms/'
    | '/stores/'
    | '/employees/$employeeId/edit'
    | '/employees/$employeeId/records'
    | '/forms/id/$formId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EarlyPaymentsApproveRoute: typeof EarlyPaymentsApproveRoute
  ReimbursementsListRoute: typeof ReimbursementsListRoute
  AccountNewTestUserLazyRoute: typeof AccountNewTestUserLazyRoute
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  AuthResetPasswordLazyRoute: typeof AuthResetPasswordLazyRoute
  EarlyPaymentsNewRequestLazyRoute: typeof EarlyPaymentsNewRequestLazyRoute
  EarlyPaymentsRequestsLazyRoute: typeof EarlyPaymentsRequestsLazyRoute
  EarlyPaymentsSettingsLazyRoute: typeof EarlyPaymentsSettingsLazyRoute
  EmployeesAddLazyRoute: typeof EmployeesAddLazyRoute
  EmployeesEditSalaryLazyRoute: typeof EmployeesEditSalaryLazyRoute
  EmployeesExportsLazyRoute: typeof EmployeesExportsLazyRoute
  EnterprisesOverviewLazyRoute: typeof EnterprisesOverviewLazyRoute
  EnterprisesUsersLazyRoute: typeof EnterprisesUsersLazyRoute
  ErpMovementsLazyRoute: typeof ErpMovementsLazyRoute
  ErpProductsLazyRoute: typeof ErpProductsLazyRoute
  ReimbursementsCreateLazyRoute: typeof ReimbursementsCreateLazyRoute
  EmployeesIndexRoute: typeof EmployeesIndexRoute
  ErpIndexRoute: typeof ErpIndexRoute
  AccountIndexLazyRoute: typeof AccountIndexLazyRoute
  FormsIndexLazyRoute: typeof FormsIndexLazyRoute
  StoresIndexLazyRoute: typeof StoresIndexLazyRoute
  EmployeesEmployeeIdEditLazyRoute: typeof EmployeesEmployeeIdEditLazyRoute
  EmployeesEmployeeIdRecordsLazyRoute: typeof EmployeesEmployeeIdRecordsLazyRoute
  FormsIdFormIdLazyRoute: typeof FormsIdFormIdLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/': {
      id: '/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account/new-test-user': {
      id: '/account/new-test-user'
      path: '/account/new-test-user'
      fullPath: '/account/new-test-user'
      preLoaderRoute: typeof AccountNewTestUserLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-payments/approve': {
      id: '/early-payments/approve'
      path: '/early-payments/approve'
      fullPath: '/early-payments/approve'
      preLoaderRoute: typeof EarlyPaymentsApproveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-payments/new-request': {
      id: '/early-payments/new-request'
      path: '/early-payments/new-request'
      fullPath: '/early-payments/new-request'
      preLoaderRoute: typeof EarlyPaymentsNewRequestLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-payments/requests': {
      id: '/early-payments/requests'
      path: '/early-payments/requests'
      fullPath: '/early-payments/requests'
      preLoaderRoute: typeof EarlyPaymentsRequestsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/early-payments/settings': {
      id: '/early-payments/settings'
      path: '/early-payments/settings'
      fullPath: '/early-payments/settings'
      preLoaderRoute: typeof EarlyPaymentsSettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/': {
      id: '/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof EmployeesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/add': {
      id: '/employees/add'
      path: '/employees/add'
      fullPath: '/employees/add'
      preLoaderRoute: typeof EmployeesAddLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/edit-salary': {
      id: '/employees/edit-salary'
      path: '/employees/edit-salary'
      fullPath: '/employees/edit-salary'
      preLoaderRoute: typeof EmployeesEditSalaryLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/exports': {
      id: '/employees/exports'
      path: '/employees/exports'
      fullPath: '/employees/exports'
      preLoaderRoute: typeof EmployeesExportsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprises/overview': {
      id: '/enterprises/overview'
      path: '/enterprises/overview'
      fullPath: '/enterprises/overview'
      preLoaderRoute: typeof EnterprisesOverviewLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enterprises/users': {
      id: '/enterprises/users'
      path: '/enterprises/users'
      fullPath: '/enterprises/users'
      preLoaderRoute: typeof EnterprisesUsersLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/erp/': {
      id: '/erp/'
      path: '/erp'
      fullPath: '/erp/'
      preLoaderRoute: typeof ErpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/erp/movements': {
      id: '/erp/movements'
      path: '/erp/movements'
      fullPath: '/erp/movements'
      preLoaderRoute: typeof ErpMovementsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/erp/products': {
      id: '/erp/products'
      path: '/erp/products'
      fullPath: '/erp/products'
      preLoaderRoute: typeof ErpProductsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/': {
      id: '/forms/'
      path: '/forms'
      fullPath: '/forms/'
      preLoaderRoute: typeof FormsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reimbursements/create': {
      id: '/reimbursements/create'
      path: '/reimbursements/create'
      fullPath: '/reimbursements/create'
      preLoaderRoute: typeof ReimbursementsCreateLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reimbursements/list': {
      id: '/reimbursements/list'
      path: '/reimbursements/list'
      fullPath: '/reimbursements/list'
      preLoaderRoute: typeof ReimbursementsListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores/': {
      id: '/stores/'
      path: '/stores'
      fullPath: '/stores/'
      preLoaderRoute: typeof StoresIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/edit': {
      id: '/employees/$employeeId/edit'
      path: '/employees/$employeeId/edit'
      fullPath: '/employees/$employeeId/edit'
      preLoaderRoute: typeof EmployeesEmployeeIdEditLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/records': {
      id: '/employees/$employeeId/records'
      path: '/employees/$employeeId/records'
      fullPath: '/employees/$employeeId/records'
      preLoaderRoute: typeof EmployeesEmployeeIdRecordsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forms/id/$formId': {
      id: '/forms/id/$formId'
      path: '/forms/id/$formId'
      fullPath: '/forms/id/$formId'
      preLoaderRoute: typeof FormsIdFormIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EarlyPaymentsApproveRoute: EarlyPaymentsApproveRoute,
  ReimbursementsListRoute: ReimbursementsListRoute,
  AccountNewTestUserLazyRoute: AccountNewTestUserLazyRoute,
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  AuthResetPasswordLazyRoute: AuthResetPasswordLazyRoute,
  EarlyPaymentsNewRequestLazyRoute: EarlyPaymentsNewRequestLazyRoute,
  EarlyPaymentsRequestsLazyRoute: EarlyPaymentsRequestsLazyRoute,
  EarlyPaymentsSettingsLazyRoute: EarlyPaymentsSettingsLazyRoute,
  EmployeesAddLazyRoute: EmployeesAddLazyRoute,
  EmployeesEditSalaryLazyRoute: EmployeesEditSalaryLazyRoute,
  EmployeesExportsLazyRoute: EmployeesExportsLazyRoute,
  EnterprisesOverviewLazyRoute: EnterprisesOverviewLazyRoute,
  EnterprisesUsersLazyRoute: EnterprisesUsersLazyRoute,
  ErpMovementsLazyRoute: ErpMovementsLazyRoute,
  ErpProductsLazyRoute: ErpProductsLazyRoute,
  ReimbursementsCreateLazyRoute: ReimbursementsCreateLazyRoute,
  EmployeesIndexRoute: EmployeesIndexRoute,
  ErpIndexRoute: ErpIndexRoute,
  AccountIndexLazyRoute: AccountIndexLazyRoute,
  FormsIndexLazyRoute: FormsIndexLazyRoute,
  StoresIndexLazyRoute: StoresIndexLazyRoute,
  EmployeesEmployeeIdEditLazyRoute: EmployeesEmployeeIdEditLazyRoute,
  EmployeesEmployeeIdRecordsLazyRoute: EmployeesEmployeeIdRecordsLazyRoute,
  FormsIdFormIdLazyRoute: FormsIdFormIdLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
